import QuizService from 'src/modules/quiz/quizService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'QUIZ_VIEW';

const quizViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: quizViewActions.FIND_STARTED,
      });

      const record = await QuizService.find(id);
      
      dispatch({
        type: quizViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: quizViewActions.FIND_ERROR,
      });

      getHistory().push('/quiz');
    }
  },
};

export default quizViewActions;
